import { useSetAtom } from 'jotai';

import {
  neLatAtom,
  neLonAtom,
  swLatAtom,
  swLonAtom,
  userLatAtom, userLonAtom,
} from '../../../../atoms/shopsInMapAtoms';

function useOnBoundChange() {
  const setNeLat = useSetAtom(neLatAtom);
  const setNeLon = useSetAtom(neLonAtom);
  const setSwLat = useSetAtom(swLatAtom);
  const setSwLon = useSetAtom(swLonAtom);
  const setUserLat = useSetAtom(userLatAtom);
  const setUserLon = useSetAtom(userLonAtom);
  return (props:{neLon: number, neLat: number, swLon: number, swLat: number, lat: number, lng: number}) => {
    const {
      neLon, swLon, neLat, swLat, lat, lng,
    } = props;
    setNeLat(neLat);
    setNeLon(neLon);
    setSwLat(swLat);
    setSwLon(swLon);
    setUserLat(lat);
    setUserLon(lng);
  };
}

export default useOnBoundChange;
